import { useEffect, useState } from "react";
import { api, formatCurrency, formatError } from "../lib/api";
import { PageHeader, Modal } from "../components/ui-kit";
import { Send, Package, Router as RouterIcon, Search } from "lucide-react";

export default function CompanyStockPage() {
  const [tab, setTab] = useState("materials");
  const [materials, setMaterials] = useState([]);
  const [units, setUnits] = useState([]);
  const [techs, setTechs] = useState([]);
  const [q, setQ] = useState("");

  // Modals
  const [mOpen, setMOpen] = useState(false);
  const [mForm, setMForm] = useState({ material: null, technician_id: "", quantity: 1 });
  const [mErr, setMErr] = useState("");

  const [uOpen, setUOpen] = useState(false);
  const [uForm, setUForm] = useState({ unit: null, technician_id: "" });
  const [uErr, setUErr] = useState("");

  const load = () => {
    api.get("/materials").then((r) => setMaterials(r.data));
    api.get("/equipment-units?status=estoque").then((r) => setUnits(r.data));
    api.get("/users").then((r) => setTechs(r.data.filter((u) => u.role === "tecnico")));
  };
  useEffect(() => { load(); }, []);

  const openMaterialTransfer = (m) => {
    setMForm({ material: m, technician_id: "", quantity: 1 });
    setMErr(""); setMOpen(true);
  };
  const doMaterialTransfer = async () => {
    setMErr("");
    try {
      await api.post("/technician-stock/transfer", {
        technician_id: mForm.technician_id,
        material_id: mForm.material.id,
        quantity: Number(mForm.quantity),
      });
      setMOpen(false); load();
    } catch (e) { setMErr(formatError(e)); }
  };

  const openUnitAssign = (u) => {
    setUForm({ unit: u, technician_id: "" });
    setUErr(""); setUOpen(true);
  };
  const doUnitAssign = async () => {
    setUErr("");
    try {
      await api.post(`/equipment-units/${uForm.unit.id}/assign`, { technician_id: uForm.technician_id });
      setUOpen(false); load();
    } catch (e) { setUErr(formatError(e)); }
  };

  const filteredMats = materials.filter((m) =>
    !q || m.name.toLowerCase().includes(q.toLowerCase()) ||
    m.code.toLowerCase().includes(q.toLowerCase())
  );
  const filteredUnits = units.filter((u) =>
    !q || (u.serial_number || "").toLowerCase().includes(q.toLowerCase()) ||
    (u.model_name || "").toLowerCase().includes(q.toLowerCase())
  );

  return (
    <div data-testid="company-stock-page">
      <PageHeader eyebrow="Inventário" title="Estoque da Empresa">
        Tudo que está disponível na empresa: materiais consumíveis e equipamentos serializados. Transfira para o técnico direto daqui.
      </PageHeader>

      <div className="flex gap-2 mb-4 flex-wrap">
        <button
          className={`btn ${tab === "materials" ? "btn-primary" : "btn-secondary"}`}
          onClick={() => setTab("materials")}
          data-testid="tab-materials"
        >
          <Package size={15} /> Materiais ({materials.length})
        </button>
        <button
          className={`btn ${tab === "equipment" ? "btn-primary" : "btn-secondary"}`}
          onClick={() => setTab("equipment")}
          data-testid="tab-equipment"
        >
          <RouterIcon size={15} /> Equipamentos ({units.length})
        </button>
        <div className="flex-1 min-w-[220px] relative">
          <Search size={15} className="absolute left-3 top-1/2 -translate-y-1/2" style={{ color: "var(--text-mute)" }} />
          <input
            className="input pl-9"
            placeholder={tab === "materials" ? "Buscar material..." : "Buscar por SN ou modelo..."}
            value={q}
            onChange={(e) => setQ(e.target.value)}
            data-testid="company-stock-search"
          />
        </div>
      </div>

      {tab === "materials" && (
        <div className="card" data-testid="materials-stock-table">
          <table className="data">
            <thead>
              <tr>
                <th>Código</th><th>Nome</th><th>Categoria</th><th>Preço</th><th>Estoque</th><th></th>
              </tr>
            </thead>
            <tbody>
              {filteredMats.map((m) => (
                <tr key={m.id} data-testid={`company-material-${m.code}`}>
                  <td className="mono">{m.code}</td>
                  <td>{m.name}</td>
                  <td>{m.category || "-"}</td>
                  <td className="mono">{formatCurrency(m.price)}</td>
                  <td className="mono font-semibold" style={{ color: m.stock < 10 ? "#FACC15" : "inherit" }}>{m.stock}</td>
                  <td>
                    <button
                      className="btn btn-primary"
                      disabled={m.stock <= 0}
                      onClick={() => openMaterialTransfer(m)}
                      data-testid={`transfer-material-${m.code}`}
                    >
                      <Send size={13} /> Passar ao Técnico
                    </button>
                  </td>
                </tr>
              ))}
              {filteredMats.length === 0 && (
                <tr><td colSpan={6} className="text-center py-10 text-sm" style={{ color: "var(--text-mute)" }}>Nenhum material.</td></tr>
              )}
            </tbody>
          </table>
        </div>
      )}

      {tab === "equipment" && (
        <div className="card" data-testid="equipment-stock-table">
          <table className="data">
            <thead>
              <tr><th>Nº Série</th><th>Modelo</th><th></th></tr>
            </thead>
            <tbody>
              {filteredUnits.map((u) => (
                <tr key={u.id} data-testid={`company-unit-${u.serial_number}`}>
                  <td className="mono font-semibold">{u.serial_number}</td>
                  <td>{u.model_name}</td>
                  <td>
                    <button
                      className="btn btn-primary"
                      onClick={() => openUnitAssign(u)}
                      data-testid={`assign-unit-company-${u.serial_number}`}
                    >
                      <Send size={13} /> Passar ao Técnico
                    </button>
                  </td>
                </tr>
              ))}
              {filteredUnits.length === 0 && (
                <tr><td colSpan={3} className="text-center py-10 text-sm" style={{ color: "var(--text-mute)" }}>Nenhum equipamento no estoque da empresa.</td></tr>
              )}
            </tbody>
          </table>
        </div>
      )}

      <Modal open={mOpen} onClose={() => setMOpen(false)} title="Passar Material ao Técnico" testid="company-transfer-material-modal"
        footer={<>
          <button className="btn btn-secondary" onClick={() => setMOpen(false)}>Cancelar</button>
          <button className="btn btn-primary" onClick={doMaterialTransfer} data-testid="confirm-transfer-material">Transferir</button>
        </>}>
        {mErr && <div className="mb-3 p-2 text-sm border" style={{ background: "rgba(239,68,68,0.08)", borderColor: "rgba(239,68,68,0.3)", color: "#FCA5A5" }}>{mErr}</div>}
        {mForm.material && (
          <>
            <div className="mb-3 p-3 border" style={{ borderColor: "var(--border-strong)" }}>
              <div className="label-caps mb-1">Material</div>
              <div className="text-sm">{mForm.material.name}</div>
              <div className="text-xs mt-1" style={{ color: "var(--text-mute)" }}>
                <span className="mono">{mForm.material.code}</span> · Disponível: <b className="mono" style={{ color: "var(--text)" }}>{mForm.material.stock}</b>
              </div>
            </div>
            <label className="label-caps block mb-1">Técnico</label>
            <select className="select mb-3" value={mForm.technician_id} onChange={(e) => setMForm({ ...mForm, technician_id: e.target.value })} data-testid="transfer-material-tech">
              <option value="">Selecione</option>
              {techs.map((t) => <option key={t.id} value={t.id}>{t.name}</option>)}
            </select>
            <label className="label-caps block mb-1">Quantidade</label>
            <input
              className="input mono"
              type="number"
              min="1"
              max={mForm.material.stock}
              value={mForm.quantity}
              onChange={(e) => setMForm({ ...mForm, quantity: e.target.value })}
              data-testid="transfer-material-qty"
            />
          </>
        )}
      </Modal>

      <Modal open={uOpen} onClose={() => setUOpen(false)} title="Passar Equipamento ao Técnico" testid="company-assign-unit-modal"
        footer={<>
          <button className="btn btn-secondary" onClick={() => setUOpen(false)}>Cancelar</button>
          <button className="btn btn-primary" onClick={doUnitAssign} data-testid="confirm-assign-unit-company">Atribuir</button>
        </>}>
        {uErr && <div className="mb-3 p-2 text-sm border" style={{ background: "rgba(239,68,68,0.08)", borderColor: "rgba(239,68,68,0.3)", color: "#FCA5A5" }}>{uErr}</div>}
        {uForm.unit && (
          <>
            <div className="mb-3 p-3 border" style={{ borderColor: "var(--border-strong)" }}>
              <div className="label-caps mb-1">Equipamento</div>
              <div className="text-sm">{uForm.unit.model_name}</div>
              <div className="text-xs mono mt-1" style={{ color: "var(--text-mute)" }}>SN: <b style={{ color: "var(--text)" }}>{uForm.unit.serial_number}</b></div>
            </div>
            <label className="label-caps block mb-1">Técnico</label>
            <select className="select" value={uForm.technician_id} onChange={(e) => setUForm({ ...uForm, technician_id: e.target.value })} data-testid="assign-unit-company-tech">
              <option value="">Selecione</option>
              {techs.map((t) => <option key={t.id} value={t.id}>{t.name}</option>)}
            </select>
          </>
        )}
      </Modal>
    </div>
  );
}
